import { authorizedAction } from 'api'
import { ErrorProp } from './'

type ClearDevicesResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type ClearDevicesProps = {
  userId?: string
}

export async function clearDevices({
  userId,
}: ClearDevicesProps): Promise<ClearDevicesResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Devices.Clear',
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as ClearDevicesResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
